import React from "react";
import Button from "@src/components/button/Button01";
import { View, Text, Modal, TouchableWithoutFeedback } from "react-native";
import useStyles from "./styles.css";
import colors from "@assets/colors";
import SVGIcon from "@assets/svg";

const Limit100MB = (props: any) => {
  const styles = useStyles();

  const onPressed = () => {
    if (props.onClose) props.onClose();
    if (props.onProceed) props.onProceed();
  };

  return (
    <Modal
      transparent
      visible={props.visible}
      animationType={"none"}
      onRequestClose={props.onClose}
      supportedOrientations={[
        "portrait",
        "portrait-upside-down",
        "landscape",
        "landscape-left",
        "landscape-right",
      ]}
    >
      <TouchableWithoutFeedback onPress={props.onClose}>
        <View style={styles.container}>
          <View style={[ styles.v_modal ]} >
            {/*<SVGIcon name="Delete" width={72} height={85} fill={colors.colorPrimary} />*/}
            <Text style={styles.t_title}>Storage Limit Reached</Text>
            <Text style={styles.t_message}>
                You've used up your 100 MB upload limit on the Free Plan.{'\n'}
                To continue uploading and signing documents, upgrade to{'\n'}a <Text style={styles.t_message_bold}>Professional Plan</Text> and unlock higher limits along with{'\n'}
                advanced features.
            </Text>
            <View style={{flexDirection: "row", alignItems: "center"}}>
              <Button
                label="Back to Dashboard"
                onPress={props.onClose}
                style={styles.btn_cancel}
                labelStyle={styles.label_cancel}
              />
              <View style={styles.divider} />
              <Button
                label="Upgrade Plan"
                onPress={onPressed}
                style={styles.btn_proceed}
                labelStyle={styles.label_proceed}
              />
            </View>
          </View>
        </View>
      </TouchableWithoutFeedback>
    </Modal>
  );
};

export default Limit100MB;
